import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Products from "./components/Products";
import Vision from "./components/Vision";
import Quality from "./components/Quality";
import CMF from "./components/CMF";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./App.css";

const Home: React.FC = () => (
  <>
    <Hero />
    <About />
    <Products />
    <Vision />
    <Quality />
    <CMF />
    <Contact />
  </>
);

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/vision" element={<Vision />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
